// extracted by mini-css-extract-plugin
export default {"lightScrollBox":"CompetitionInfo_lightScrollBox__TWVuQ","scrollBoxStyle":"CompetitionInfo_scrollBoxStyle__2UgbR"};